import { matchRoutes, type RouteObject } from "react-router";

let sentryRouteConfig: RouteObject[] = [];

export const setSentryRouteConfig = (routes: RouteObject[]): void => {
  sentryRouteConfig = routes;
};

const appendRoutePath = (parentPath: string, routePath: string): string => {
  if (routePath.startsWith("/")) {
    return routePath;
  }

  if (!parentPath || parentPath === "/") {
    return `/${routePath}`;
  }

  return `${parentPath.replace(/\/$/, "")}/${routePath}`;
};

const resolveMatchedRouteTemplate = (pathname: string): string | undefined => {
  const matchedRoutes = matchRoutes(sentryRouteConfig, pathname);

  if (!matchedRoutes) {
    return undefined;
  }

  let routeTemplate = "";

  for (const { route } of matchedRoutes) {
    if (route.path === "*") {
      return undefined;
    }

    if (route.path) {
      routeTemplate = appendRoutePath(routeTemplate, route.path);
    }
  }

  return routeTemplate || undefined;
};

export const resolveSentryRouteTemplate = (pathname: string): string => {
  return resolveMatchedRouteTemplate(pathname) ?? pathname;
};
